import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import instaplayForm from './modules/instaplayForm'
import instaplays from './modules/instaplays'
import auth from './modules/auth'
import notification from './modules/notification'
import thumbnails from './modules/thumbnails'
import admin from "./modules/admin"
import layout from "./modules/layout"

const actions = {
    async resetState({commit, dispatch}) {
        commit('admin/resetState')
        commit('auth/resetState')
        commit('instaplays/resetState')
        commit('notification/resetState')
        commit('layout/resetState')
        await dispatch('resetInstaplayFormState')
    },
    resetInstaplayFormState({commit}) {
        commit('instaplayForm/resetState')
        commit('instaplayForm/contestants/resetState')
        commit('instaplayForm/register/resetState')
        commit('instaplayForm/timing/resetState')
        commit('instaplayForm/winner/resetState')
        commit('instaplayForm/share/resetState')
    }
}

export default new Vuex.Store({
    actions,
    modules : {
        instaplayForm,
        auth,
        instaplays,
        notification,
        thumbnails,
        admin,
        layout
    }
})
